import React from 'react';
import { Box, Paper, Stack, Typography, Chip, Avatar,Link } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { userService } from '../../../services/userService';
import { RecentUser } from '../../../services/dashboardService';

const users = new Array(6).fill({
  name: 'Andy Moriz',
  role: 'Gensize Admin',
});

interface UsersListProps {
  users: RecentUser[];
}

const UsersList: React.FC<UsersListProps> = ({ users }) => (
  <Paper elevation={3} sx={{ p: 2, borderRadius: "12px" }}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Typography fontWeight={600} fontSize="22px" fontFamily="Poppins,sans-serif" color='#132F5F'>Users</Typography>

      <Stack direction="row" spacing={0.5} alignItems="center">
        <Link href="/users" style={{ textDecoration: 'none' }}>
      <Typography color="#203A6B" fontSize={14} fontFamily="Poppins, sans-serif" sx={{ cursor: 'pointer' }}>
        All Users
      </Typography>
      </Link>
      <ArrowForwardIcon fontSize="small" sx={{color:'#FF544B', cursor:"pointer"}} />
      </Stack>
    </Box>
    <Stack spacing={1} sx={{ maxHeight: 400, overflowY: 'auto' }}>
      {(() => {
        const filteredUsers = users
          .filter(user => user.username && user.roles && user.roles.length > 0)
          .slice(0, 6);
        
        if (filteredUsers.length === 0) {
          return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100px">
              <Typography color="text.secondary" fontSize="14px">
                No users found
              </Typography>
            </Box>
          );
        }
        
        return filteredUsers.map((user, i) => (
        <Stack key={i} direction="row" alignItems="center" spacing={1}>
          <Avatar 
            sx={{ 
              bgcolor: '#ECECEC', 
              fontSize: 16, 
              color: "#3774EE",
              width: 40,
              height: 40,
              border: '2px solid #E5E7EB'
            }}
            src={user.profile_picture || undefined}
            alt={`${user.username}'s profile picture`}
            onError={(e) => {
              // Hide the image if it fails to load, fallback to initials
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          >
            {user.username[0].toUpperCase()}
          </Avatar>
          <Box flex={1}>
            <Typography fontSize={14} fontWeight={500}>{user.username}</Typography>
            <Typography fontSize={11} fontWeight={600} color="#919190">
              {user.roles.length > 0 ? userService.mapRoleToDisplay(user.roles[0]) : 'No Role'}
            </Typography>
          </Box>
          <Chip
            label={user.roles.length > 0 ? userService.mapRoleToDisplay(user.roles[0]) : 'No Role'}
            size="small"
            sx={{ fontSize: 11, backgroundColor: "#ECECEC", color: "#203A6B", fontWeight: "600" }}
          />
        </Stack>
      ));
      })()}
    </Stack>
  </Paper>
);

export default UsersList;

